module.exports = __webpack_public_path__ + "img/spring_trip-20160416-10-1024x768.a4c7d7e7.jpg";